<template>

    <nav class="navbar app-navbar is-light is-fixed-top">
        <div class="navbar-brand">
            <a class="navbar-item logo" href="#">
                <figure>
                  <img src="/images/proyoga_txt.png">
                </figure>
            </a>
            <a class="navbar-item"
                @click="toggleMenu(isTouch)">
                <span class="icon is-small">
                    <fa icon="bars"
                        :class="{ 'rotate': !menu.isExpanded || !menu.isVisible }"/>
                </span>
            </a>
            <div class="navbar-item">
              <small>Suporte de Segunda à Sexta, das 09:00 às 18:00:</br>WhatsApp 71-98785-7248/suporteproyoga@gmail.com</small>
            </div>

            <div class="navbar-item"
                v-if="impersonating">
                <button class="button is-small is-warning"
                    @click="$root.$emit('stop-impersonating')"
                    v-tooltip="__('Impersonating')">
                    <span class="icon is-small">
                        <fa icon="user"/>
                    </span>
                    <span class="icon is-small">
                        <fa icon="times"/>
                    </span>
                </button>
            </div>
            <div class="is-pulled-right is-flex"
                v-if="isTouch">
                <search v-if="!isMobile"/>
                <notifications/>
                <profile-control/>
            </div>
        </div>
        <div class="navbar-menu">
            <div class="navbar-end"
                v-if="!isTouch">
                <div class="is-pulled-right is-flex">
                    <search />
                </div>
                <profile-control/>
            </div>
        </div>
    </nav>

</template>

<script>

import { mapState, mapMutations } from 'vuex';
import { VTooltip } from 'v-tooltip';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faBars, faCode, faUser, faTimes } from '@fortawesome/free-solid-svg-icons';

import Notifications from './Notifications.vue';
import SettingsControl from './SettingsControl.vue';
import ProfileControl from './ProfileControl.vue';
import Search from './Search.vue';

library.add(faBars, faCode, faUser, faTimes);

export default {
    name: 'Navbar',

    directives: { tooltip: VTooltip },

    components: {
        Notifications, SettingsControl, ProfileControl, Search,
    },

    computed: {
        ...mapState(['meta', 'impersonating']),
        ...mapState('layout', ['isMobile', 'isTouch', 'menu']),
    },

    methods: {
        ...mapMutations('layout/menu', { toggleMenu: 'toggle' }),
    },
};

</script>

<style lang="scss" scoped>

    .navbar {
        z-index: 3;

        -webkit-box-shadow: 0 1px 1px hsla(0,0%,4%,.2);
        box-shadow: 0 1px 1px hsla(0,0%,4%,.2);
        background-color: white;

        .fa-bars {
            transition: transform .300s;

            &.rotate {
                transform: rotate(90deg);
            }
        }

        .is-pulled-right {
            margin-left: auto;
        }
    }

</style>



// WEBPACK FOOTER //
// resources/js/core/structure/navbar/Navbar.vue